
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const PortfolioPage = lazy(() => import('../pages/portfolio/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const QuotePage = lazy(() => import('../pages/quote/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const CareersPage = lazy(() => import('../pages/careers/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/portfolio',
    element: <PortfolioPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/quote',
    element: <QuotePage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/careers',
    element: <CareersPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
